import type { MentorsCardProps } from "../_model";
import SmsIcon from "../assets/icons/sms.svg";
import LinkedInIcon from "../assets/icons/LinkedIn.svg";
import TwitterIcon from "../assets/icons/Twitter.svg";
import { global } from ":shared/app";

export function MentorsCard(props: MentorsCardProps) {
  const badge = global.store.actions.flavors.getBadgeStyle({ track: props.track });
  const links = {
    email: processLink(props.email),
    twitter: processLink(props.twitter),
    linkedin: processLink(props.linkedin),
  };

  function processLink(link: string) {
    const exist = link != undefined && link.length > 0;
    // console.log("link :: ", link, " :: ", exist);
    return {
      exist,
      value: link,
      class: exist ? "cursor-pointer" : "opacity-40 cursor-not-allowed",
    };
  }
  function handleBooKSession() {
    global.store.actions.popop.pushModal({
      title: props.name,
      element: () => <iframe src={props.calendly} class="w-full h-full" />,
    });
  }

  return (
    <section class="relative w-full h-315px flex flex-col rounded-xl bg-bg px-3 pt-2 overflow-hidden border-border-card border-1 border-solid pb2 <sm:(h-350px)">
      <div class="flex flex-row w-full min-h-45% gap-2 overflow-hidden <sm:(w-full min-h-45%)">
        <div class="flex min-w-100px w-100px max-w-100px min-h-100px h-100px max-h-100px rounded-full self-center overflow-hidden">
          <img class="w-full h-full object-cover" src={props?.image ?? "/images/placeholders/person.png"} alt="img" />
        </div>
        <div class="flex flex-col w-full h-full gap-1 overflow-hidden">
          <p class="w-full h-fit font-bold text-16px py-1 overflow-y-hidden overflow-x-auto whitespace-nowrap lt-sm:(w-full)">
            {props?.name ?? "No Name"}
          </p>
          <p
            style={badge.style}
            class="w-fit h-fit  text-13px py-1 px-2 rounded-full bg-brand-alt text-brand text-start capitalize whitespace-nowrap"
          >
            {props?.track ?? "No track"}
          </p>
          <div class="flex flex-row w-full h-fit justify-start items-center gap-2">
            <a class={links.email.class} href={links.email.exist ? `mailto:${links.email.value}` : null}>
              <SmsIcon class="bg-brand px-5px rounded-sm w-26px h-26px" />
            </a>
            <a class={links.twitter.class} href={links.twitter.value} target="_blank">
              <TwitterIcon class="bg-brand px-5px rounded-sm w-26px h-26px" />
            </a>
            <a class={links.linkedin.class} href={links.linkedin.value} target="_blank">
              <LinkedInIcon class="bg-brand px-5px rounded-sm w-26px h-26px" />
            </a>
          </div>
        </div>
      </div>
      <p class=" w-full text-14px px-1 h-full  text-text-alt text-start py-1 overflow-auto scrollbar">{props?.bio}</p>
      <button onClick={handleBooKSession} class="form-btn mt-1.5">
        Book session
      </button>
    </section>
  );
}
